(function () {
  if (window.Shopify && Shopify.designMode) return;

  const toolbar = document.querySelector('.cloud-search-toolbar');
  const root = document.getElementById('cloud_search_filters_root');
  const nativeSort = document.getElementById('SortBy');

  function toggleCloudSearchFilters() {
    const trigger =
      document.querySelector('.cloud-search-page-controls__filters-link span') ||
      document.querySelector('.cloud-search-page-controls__filters-link');
    if (trigger) trigger.click();
  }

  document.querySelectorAll('[data-cloud-search-filter-toggle]').forEach(function (el) {
    el.addEventListener('click', toggleCloudSearchFilters);
  });

  function hasAppSort() {
    return Boolean(
      document.querySelector('.cloud-search-page-controls__sort, select.cloud-search-sort-select')
    );
  }

  function syncSortVisibility() {
    if (!toolbar) return;
    toolbar.classList.toggle('has-cloud-search-sort', hasAppSort());
  }

  if (nativeSort) {
    nativeSort.addEventListener('change', function (event) {
      if (!event.isTrusted) return;

      const appSelect = document.querySelector('select.cloud-search-sort-select');
      if (appSelect) {
        appSelect.value = nativeSort.value;
        appSelect.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      const url = new URL(window.location.href);
      if (url.searchParams.get('sort_by') === nativeSort.value) return;

      url.searchParams.set('sort_by', nativeSort.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  }

  if (root) {
    const observer = new MutationObserver(syncSortVisibility);
    observer.observe(root, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', syncSortVisibility);
})();
